import { LeftOutlined, UploadOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import Aside from "../Aside";
import Header from "../Header";
import UploadFile from "../../pages/Dashboard/UploadFile";
import { Button } from "antd";
import { useSelector } from "react-redux";
import downloadButton_Icon from "../../assets/svg/downloadButton_Icon.svg";
import { useTranslation } from "react-i18next";
import BasicPackageRestrictionModal from "../RestrictionModal/BasicPackageRestrictionModal";
const Layout = ({ title, children, goBack }) => {
  const [visible, setVisible] = useState(false);
  const [openRestrictionModal, setOpenRestrictionModal] = useState(false);
  const { sideBar } = useSelector((state) => state.loadingSlice);
  const { packages } = useSelector((state) => state.userSlice);
  const { t } = useTranslation();
  return (
    <div className="Layout">
      {sideBar && <Aside />}
      <main className="main">
        <Header isMainHeader={true} />
        <div className="container">
          <div className="page-title">
            <span>
              {goBack && (
                <LeftOutlined
                  style={{ fontSize: 18 }}
                  title="Go Back"
                  onClick={goBack}
                />
              )}
              {t(`label.${title?.toLowerCase()}`)}
            </span>
            <Button
              onClick={() => {
                packages[0]?.packageName === "Basic"
                  ? setOpenRestrictionModal(true)
                  : setVisible(true);
              }}
              type="primary"
              icon={<UploadOutlined size={"large"} />}
              className="primary-btn"
            >
              {t("label.upload")}
            </Button>
          </div>
          {children}
        </div>
        <BasicPackageRestrictionModal
          open={openRestrictionModal}
          setOpen={setOpenRestrictionModal}
        />
        <UploadFile setVisible={setVisible} visible={visible} />
      </main>
    </div>
  );
};

export default Layout;
